// extracted by mini-css-extract-plugin
export default {"incompletePill":"dealTasksPill_incompletePill__c5pkQ","pendingPill":"dealTasksPill_pendingPill__Vi3xT","completedPill":"dealTasksPill_completedPill__EdRJz"};